export default __webpack_public_path__ + "static/media/Factory2.0dc7e912.jpg";